import type { RouteRecordRaw, Router } from 'vue-router'

/**
 * Public-only routes — Login, password recovery, error page.
 * Mounted under the `plain` layout template via the parent layout
 * group (see `routes/index.ts`).
 *
 * `meta.template: 'plain'` tells `DefaultLayout` which template
 * to render. `meta.guest: true` tells the auth guard this route
 * is accessible without authentication.
 *
 * `meta.externalAuth: true` (on Login) → if the actor is ALREADY
 * authenticated, redirect to Dashboard instead of showing login.
 */
export const guestRoutes = (_router: Router): RouteRecordRaw[] => [
  {
    path: 'login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { guest: true, externalAuth: true, template: 'plain' },
  },
  {
    path: 'forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: { guest: true, template: 'plain' },
  },
  {
    path: 'reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/auth/ResetPasswordView.vue'),
    meta: { guest: true, template: 'plain' },
  },
  {
    path: 'error',
    name: 'ErrorPage',
    component: () => import('@/views/ErrorView.vue'),
    meta: { guest: true, template: 'plain' },
  },
]
